
import DoughnutLabel from "chartjs-plugin-doughnutlabel-v3";
import { Doughnut } from 'react-chartjs-2'
import {
    Chart,
    Legend,
    DoughnutController,
    registerables
} from "chart.js";
import { useTranslation } from 'react-i18next';
import { isIterableArray, toFormatPrice } from '../../../utils/utils';
import moment from "moment";
import useIsMobile from "../../../utils/useIsMobile";
Chart.register(
    ...registerables,
    DoughnutController,
    DoughnutLabel,
    Legend
);


// export const getDoughnutTotal = function (myDoughnutChart, fixedCount, text, forRemove) {
//     const arr = myDoughnutChart.config.data.datasets[0].data
//     const sum = arr.reduce(
//         (acc, item, index) => {
//             const isR = isIterableArray(forRemove) ? forRemove.findIndex(i => i.index === index) : 0
//             if (isR <= 0) {
//                 acc = acc + item
//                 return acc
//             }
//             else return acc
//             //  a + b
//         }, 0
//     );
//     return `${toFormatPrice(sum, fixedCount)} ${text ? text : ''}`;
// };
const DoughnutGraph = (props) => {

    const { currentData, month, year, graphTarifId, graphPriceId, children } = props

    const isMobile = useIsMobile(1450)

    const { t } = useTranslation()
    const getTotalByVal = function (arr, fixedCount, text) {
        const sum = arr.reduce(
            (acc, item, index) => {
                acc = acc + item
                return acc
            }, 0
        );
        return `${toFormatPrice(sum, fixedCount)} ${text ? text : ''}`;
    };
    const options = {
        maintainAspectRatio: false,
        plugins: {
            tooltip: {
                backgroundColor: '#fff',
                bodyColor: '#444248',
                titleColor: '#444248',
                titleSpacing: 8,
                caretSize: 0,
                cornerRadius: 12,
                borderColor: '#EDEDED',
                borderWidth: 2,
                padding: 16,
                titleFont: {
                    size: 18
                },
                bodyFont: {
                    size: 18
                },

                callbacks: {
                    title: function (tooltipItems) {
                        return tooltipItems[0].label
                    },
                    labelColor: function (context) {
                        return {
                            backgroundColor: context.dataset.backgroundColor[context.dataIndex],
                            border: 0,
                            boxWidth: 10,
                            boxHeight: 10,
                            pointStyle: 'circle',
                            useBorderRadius: true,
                            borderRadius: 5,
                        }
                    }
                }
            },
            legend: {
                // display: !isMobile,
                display: false,
                position: 'bottom',
                align: 'center',
                labels: {
                    boxWidth: 8,
                    boxHeight: 8,
                    usePointStyle: true,
                    pointStyle: 'circle',
                    useBorderRadius: true,
                    borderRadius: 4,

                },
            },
            datalabels: {
                formatter: function (value, context) {
                    return `${toFormatPrice(value)}`;
                },
                color: function (context) {
                    return '#444248';
                },
                font: {
                    weight: 500,
                    size: isMobile ? 9 : 12,
                    family: 'Inter'
                }
            },
        }
    }

    const dataPrice = {
        labels: currentData.labels1.map(label => t(`analytics.pie_${label}`)),
        datasets: [
            {
                data: currentData.values1,
                backgroundColor: currentData.colors1,
                borderWidth: 0,
            },
        ],
        doughnutlabel: {
            display: true,
        }
    };
    const dataTotal = {
        labels: currentData.labels2.map(label => t(`analytics.pie_${label}`)),
        datasets: [
            {
                data: currentData.values2,
                backgroundColor: currentData.colors2,
                borderWidth: 0,
            },
        ],
    };

    return (
        <div className='flex flex-col tab:flex-row lap:flex-col items-center gap-[30px] tab:gap-0'>
            <div className={` h-[300px] mx-auto`}>
                <Doughnut
                    id={graphTarifId}
                    className="w-full"
                    updateMode='resize'
                    data={dataPrice}
                    options={{
                        plugins: {
                            ...options.plugins, ...{
                                doughnutLabel: {
                                    spacing: 15,
                                    labels: [
                                        {
                                            text: t('analytics.dataPriceTitle'),
                                            font: {
                                                size: isMobile ? "9" : '11',
                                                family: "Inter",
                                                weight: "400",
                                                lineHeight: 2
                                            },
                                            color: "#767579",
                                        },
                                        {
                                            text: (e) => getTotalByVal(currentData.values1, 2),
                                            font: {
                                                size: isMobile ? "11" : '14',
                                                family: "Inter",
                                                weight: "400",
                                                lineHeight: 1.2
                                            },
                                            color: "#2D2B32",
                                        },
                                        {
                                            text: t('grnMvtGod'),
                                            font: {
                                                size: isMobile ? "11" : '14',
                                                family: "Inter",
                                                weight: "400",
                                                lineHeight: 1.2
                                            },
                                            color: "#2D2B32",
                                        },
                                        {
                                            text: (month && year) ? moment(`${month}-${year}`, 'MM-YYYY').format('MMMM YYYY') : '',
                                            font: {
                                                size: (month && year) ? isMobile ? "9" : '12' : 0,
                                                family: "Inter",
                                                weight: "400",
                                                lineHeight: (month && year) ? 2 : 0
                                            },
                                            color: "#767579"
                                        }
                                    ]
                                }
                            }
                        }
                    }}
                />
            </div>
            {children}
            <div className={` h-[300px] mx-auto`}>
                <Doughnut
                    id={graphPriceId}
                    className="w-full"
                    updateMode='resize'
                    data={dataTotal}
                    options={{
                        plugins: {
                            ...options.plugins, ...{
                                doughnutLabel: {
                                    labels: [
                                        {
                                            text: t('analytics.dataTotalTitle'),
                                            font: {
                                                size: isMobile ? "9" : '12',
                                                family: "Inter",
                                                weight: "400",
                                                lineHeight: 2,
                                            },
                                            color: "#767579"
                                        },
                                        {
                                            text: (e) => getTotalByVal(currentData.values2, 2, t('grn')),
                                            font: {
                                                size: isMobile ? "11" : '14',
                                                family: "Inter",
                                                weight: "400",
                                                lineHeight: 1.2,
                                            },
                                            color: "#2D2B32"
                                        },
                                        {
                                            text: (month && year) ? moment(`${month}-${year}`, 'MM-YYYY').format('MMMM YYYY') : '',
                                            font: {
                                                size: (month && year) ? isMobile ? "9" : '12' : 0,
                                                family: "Inter",
                                                weight: "400",
                                                lineHeight: (month && year) ? 2 : 0
                                            },
                                            color: "#767579"
                                        },
                                    ]
                                }
                            }
                        }
                    }}
                />
            </div>
        </div>
    )
}

export default DoughnutGraph